<div class="create-subject-dialog">
    <div class="dialog-header">
        <h2>{{ 'request_v2.category_form.create_subject' | translate }}</h2>
        <button class="close-button" mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body">
        <form [formGroup]="subjectForm">
            <!-- Name fields -->
            <div formGroupName="name">
                <app-form-input-v2
                    [label]="'request_v2.category_form.name_en' | translate"
                    [type]="'text'"
                    [placeholder]="'request_v2.category_form.name_en_placeholder' | translate"
                    [invalidPass]="subjectForm.get('name.en')?.invalid && subjectForm.get('name.en')?.touched"
                    [invalidText]="'request_v2.category_form.field_required' | translate"
                    formControlName="en"
                >
                </app-form-input-v2>

                <app-form-input-v2
                    [label]="'request_v2.category_form.name_fr' | translate"
                    [type]="'text'"
                    [placeholder]="'request_v2.category_form.name_fr_placeholder' | translate"
                    [invalidPass]="subjectForm.get('name.fr')?.invalid && subjectForm.get('name.fr')?.touched"
                    [invalidText]="'request_v2.category_form.field_required' | translate"
                    formControlName="fr"
                >
                </app-form-input-v2>
            </div>

            <!-- Department Selection Section -->
            <app-select-list-v2
                [label]="'request_v2.category_form.select_department' | translate"
                [placeholder]="'request_v2.category_form.select_department_placeholder' | translate"
                [items]="departments"
                formControlName="departmentId"
            >
            </app-select-list-v2>
        </form>
    </div>

    <div class="dialog-footer">
        <button class="cancel-button" (click)="close()">
            {{ 'common.cancel' | translate }}
        </button>
        <button class="save-button" [disabled]="subjectForm.invalid || isSubmitting" (click)="createSubject()">
            <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
            <span *ngIf="!isSubmitting">{{ 'request_v2.category_form.save' | translate }}</span>
        </button>
    </div>
</div>
